import { configureStore } from '@reduxjs/toolkit';

// Import reducers

// Placeholder reducer to prevent empty reducer object error
const placeholderReducer = (state = {}) => state;

// Configure store with middleware and enhancers
export const store = configureStore({
	reducer: {
		_placeholder: placeholderReducer,
		// Add more feature reducers here
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				// Ignore these action types
				ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
			},
		}),
	devTools: import.meta.env.DEV,
});

// Infer types from store
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
